module.exports = __webpack_public_path__ + "media/src/application/media/route_5-d42e9b1d5eadf56f0cd936a3016ce8df.webp";